import state from "@/feature/OpenAccount/store/state";
import getters from "@/feature/OpenAccount/store/getters";
import modules from "@/feature/OpenAccount/store/modules";
import actions from "@/feature/OpenAccount/store/actions";
import mutations from "@/feature/OpenAccount/store/mutations";
import { Module } from "vuex";
import { IStoreRootState } from "@/store/interface";
import { OpenAccountState } from "@/feature/OpenAccount/store/interface";
import { namespace } from "vuex-class";
import { OPEN_ACCOUNT_MODULE_NAME } from "@/feature/OpenAccount/store/constants";

export const OpenAccountStore = namespace(OPEN_ACCOUNT_MODULE_NAME);

export default <Module<OpenAccountState, IStoreRootState>> {
	namespaced: true,
	state,
	getters,
	modules,
	actions,
	mutations,
}